













// This file is auto-generated by Typewriter, DO NOT MODIFY THIS FILE
/**
 * 
 */
export enum PaymentProvider { 
    Stripe = 1,
    BPoint = 2,
    Paypal = 3
}